var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientMyDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.135,
    height: 61.227,
    viewBox: "0 0 53.135 61.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 263"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15",
    d: "M41.936-511.6a4.92 4.92 0 0 0-3.131 2.716l-.391.83-.036 7.127-.036 7.139-.688.13a4.2 4.2 0 0 0-2.941 2.538c-.2.581-.213 1.577-.213 18.7 0 17.231.012 18.109.213 18.713a4.625 4.625 0 0 0 2.075 2.241l.676.332H84.07l.676-.332a4.625 4.625 0 0 0 2.075-2.241c.2-.6.213-1.482.213-18.713 0-17.124-.012-18.12-.213-18.7a4.2 4.2 0 0 0-2.941-2.538l-.676-.13-.047-2.929c-.036-2.739-.047-2.953-.308-3.51-.4-.878-10.353-10.839-11.23-11.23l-.593-.273-14.231-.024c-12.061-.028-14.326-.005-14.859.154zm28.438 4.637c0 1.684.059 3.4.119 3.819a4.921 4.921 0 0 0 4.245 4.056c.439.047 2.111.095 3.736.107H81.4v7.768c0 7.613 0 7.768.237 8a.824.824 0 0 0 1.281-.071c.261-.3.261-.308.261-4.506 0-3.285.036-4.2.154-4.2a3 3 0 0 1 1.423.818 2.731 2.731 0 0 1 .439.818c.13.51.166 10.507.036 10.436-1.067-.546.083-.51-15.393-.569-13.531-.059-14.373-.071-14.776-.273-.652-.32-.9-.652-1.471-1.98-.878-2.016-1.731-2.917-3.06-3.2-.427-.095-2.573-.119-6.9-.095-6.262.036-6.285.036-6.783.3a3.238 3.238 0 0 1-.569.273 34.215 34.215 0 0 1 .059-4.886 2.288 2.288 0 0 1 1.245-1.411c.783-.356.771-.379.771 1.186a12.009 12.009 0 0 0 .071 1.613 1.115 1.115 0 0 0 1.055.462c.676-.166.652.213.652-9.653 0-10.139-.012-9.9.795-10.8a3.155 3.155 0 0 1 1.459-.949c.166-.047 6.522-.095 14.148-.095l13.839-.012zm9.4 6.179c-.19.024-1.423.024-2.763 0-2.716-.059-2.941-.107-3.795-.889-.937-.83-1.008-1.115-1.044-4.3l-.036-2.787 3.985 3.973c3.668 3.654 3.953 3.962 3.656 3.998zm-29.41 16.674a3.333 3.333 0 0 1 1.506 1.921c.747 1.814 1.34 2.526 2.6 3.119l.664.308 14.349.059 14.349.059.415.261a2.356 2.356 0 0 1 .712.771l.3.51.036 11.064c.024 7.436-.012 11.219-.095 11.527a2.329 2.329 0 0 1-1.245 1.435c-.451.213-1.4.225-23.184.225s-22.734-.012-23.184-.225a2.288 2.288 0 0 1-1.245-1.411c-.166-.617-.166-27.548.012-28.165a2.639 2.639 0 0 1 1.233-1.459 114.943 114.943 0 0 1 12.78-.005z",
    transform: "translate(-34.2 512.063)",
    style: {
      strokeWidth: ".6px",
      fill: "#6e7378",
      stroke: "#6f7071"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16",
    d: "M114.649-464.653a.809.809 0 0 0-.652.866c0 .854-.154.83 5.254.83h4.815l.237-.308a.71.71 0 0 0-.036-1.079l-.285-.332-4.554-.024c-2.49 0-4.649.012-4.779.047z",
    transform: "translate(-104.269 470.578)",
    style: {
      fill: "#f37b89",
      stroke: "#f37b89",
      strokeWidth: ".6px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17",
    d: "M114.218-418.787a1.033 1.033 0 0 0 .047 1.281c.237.213.5.225 4.993.225H124l.285-.332a.71.71 0 0 0 .036-1.079l-.237-.308h-4.838c-4.53 0-4.846.012-5.028.213z",
    transform: "translate(-104.288 430.297)",
    style: {
      fill: "#f37b89",
      stroke: "#f37b89",
      strokeWidth: ".6px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientMyDocuments);
export default __webpack_public_path__ + "static/media/patientMyDocuments.f0212c5231aef56666de350120b20fda.svg";
export { ForwardRef as ReactComponent };